import React, { useState } from 'react';
import styles from './Home.module.scss';
import { Redirect } from 'react-router-dom';

interface ISplashCtaCard {
  title: string[];
  subtitle: React.ReactNode;
  description: string;
  href: string;
}

const SplashCtaCard = (props: ISplashCtaCard) => {
  const [redirect, setRedirect] = useState(false);

  return redirect ? (
    <Redirect push to={props.href} />
  ) : (
    <div className={styles.ctaCard} onClick={() => setRedirect(true)}>
      <div className={styles.title}>
        <div>
          {props.title.map((t) => (
            <p style={{ margin: 0, padding: 0 }} key={t}>
              {t}
            </p>
          ))}
        </div>
      </div>
      <div
        className={styles.subtitle}
        //onClick={() => (location.href = props.href)}
      >
        {props.subtitle}
      </div>
      <div className={styles.description}>{props.description}</div>
    </div>
  );
};

export default SplashCtaCard;
